export enum TransferApplicationType {
	Transfer = 'transfer',
	Copy = 'copy'
}